import API from './request/platform';
export default {
  axios: API,
  // 初始化添加产品-精准关联产品列表
  initRulePreciseCorrelationProductList: (body) => API.post('/product/BaseInfoController/initRulePreciseCorrelationProductList', body),
  // 初始化添加产品-精准关联产品列表
  initAllRulePreciseCorrelationProductList: (body) => API.post('/product/BaseInfoController/initAllRulePreciseCorrelationProductList', body),
  // 已添加产品页面，获取当前产品详情
  getRulePreciseCorrelationAddedProductList: (body) => API.post('/product/BaseInfoController/getRulePreciseCorrelationAddedProductList', body),
  // 已添加产品页面，获取当前产品详情(全量加载)
  getAllRulePreciseCorrelationAddedProductList: (body) => API.post('/product/BaseInfoController/getAllRulePreciseCorrelationAddedProductList', body),
  // 获取主机列表  
  getHostList: (body) => API.post('/product/BaseInfoController/getHostList', body),
  // 初始化CRM 项目名称  
  getCRMInfoByConditions: (params) => API.get('/product/project/getCRMInfoByConditions', params),
  // 获取报价单基本信息
  selectProjectBaseInfoByProjectId: (params) => API.get('/product/project/model', params),
  // 保存项目基本信息
  saveProjectBaseInfo: (body) => API.post('/product/project/saveProjectBaseInfo', body),
  // 初始化加载配置组列表
  getConfigurationGroup: (params) => API.get('/product/configuration/group/list', params),
  // 添加配置组
  createConfigurationGroup: (body) => API.post('/product/configuration/group/create', body),
  // 删除配置组信息
  deleteConfigurationGroup: (params) => API.delete('/product/configuration/group/delete', params),
  // 复制配置组信息
  copyConfigurationGroup: (params) => API.get('/product/configuration/group/copy', params),
  // 我的项目(报价单)
  getProjectListByCurrentUser: (params) => API.post('/product/project/list', params),
  // 计算各类型项目金额
  getCalcProjectMoney: () => API.get('/product/project/calc'),
  // 修改配置组名称
  editConfigurationGroup: (body) => API.post('/product/configuration/group/edit', body),
  // 获取产品系列表
  getProductLineList: (params) => API.get('/product/productLine/line', params),
  // 获取产品大类列表
  getProductCategoriesList: (params) => API.get('/product/productLine/categories', params),
  // 获取产品系列列表
  getProductSeriesList: (params) => API.get('/product/productLine/series', params),
  // 搜索添加产品列表
  initProductList: (params) => API.post('/product/BaseInfoController/initProductList', params),
  // 产品查询
  queryProduct: (params) => API.post('/product/BaseInfoController/queryProduct', params),
  // 获取选择配件的产品列表
  getChoosePartList: (body) => API.post('/product/project/parts/list', body),
  // 保存选择配件并返回
  saveChoosePartList: (params) => API.post('/product/project/choose/parts', params),
  // 获取配置组下的
  getGroupProductList: (params) => API.get('/product/product/item/item', params),
  // 获取折扣信息列表
  getConfigGroupAndProductItemListByProjectId: (params) => API.get('/product/configuration/group/view', params),
  // 整单设置折扣应用计算
  applyAllDiscount: (body) => API.post('/product/price/discount/apply', body),
  // 导出分享折扣计算
  applyItemDiscount: (params) => API.put('/product/price/discount/apply/item', params),
  // 出口合规：风险检测（创建价格单第三步导出前触发）
  exportComplianceDetect: (body) => API.post('/product/exportCompliance/detect', body),
  // 出口合规：提交审查单
  exportComplianceReviewSubmit: (body) => API.post('/product/exportCompliance/review/submit', body),
  // 出口合规：批量查询报价单审查状态
  exportComplianceStatusBatch: (body) => API.post('/product/exportCompliance/status/batch', body),
  // 出口合规：手动刷新审查状态（回调未送达时的兜底）
  exportComplianceReviewRefresh: (body) => API.post('/product/exportCompliance/review/refresh', body),
  // 出口合规：人工放行留痕（检测异常时点击 Continue，操作人由服务端取当前登录用户）
  exportComplianceManualRelease: (body) => API.post('/product/exportCompliance/manual-release', body),
  // 获取当前用户信息
  getUserInfo: () => API.get('/product/project/userInfo'),
  // 获取当前登录用户信息
  getUserInfoName: () => API.get('/product/user/getUserInfo'),
  // 获取指定人分享信息
  seachUserByKey: (params) => API.get('/product/search/user', params),
  // 获取项目操作记录
  getProjectLogList: (params) => API.get('/product/project/log', params),
  // 获取项目基本信息  
  getProjectBaseInfo: (params) => API.get('/product/project/model', params),
  // 获取项目下所有的配置组以及产品信息集合
  getConfigGroupAndProductListByProjectId: (params) => API.get('/product/configuration/group/view', params),
  // 分享报价单信息
  toShare: (body) => API.post('/product/share/toShare', body),
  // 分享报价单信息,校验 
  toShareCheck:(body) => API.post("/product/share/checkShare",body),
  // 添加至配置
  createProductGroupSubItem: (body) => API.post('/product/BaseInfoController/createProductGroupSubItem', body),
  // 修改groupName
  updateGroupNameByGroupId: (params) => API.put('/product/configuration/group/edit/name', params),
  // 复制报价单项目
  copyProject: (params) => API.get('/product/project/copy', params),
  // 删除报价单(逻辑删除)
  deleteProject: (params) => API.delete('/product/project/delproject', params),
  // 删除配置组子项
  deleteGroupSubItem: (params) => API.delete('/product/product/item/deleteGroupSubItems', params),
  // 删除已选的产品
  deleteProductItem: (params) => API.delete('/product/product/item/item', params),
  // 通过配置组子项获取主机名称
  getHostNameBySubId: (subId) => API.get(`/product/product/item/hostname/${subId}`),
  // 获取字段和格式列表
  basicsConfigController: (params) => API.get('/product/basice/list', params),
  // 保存配置器下产品得数量及套数
  saveConfigProduct: (body) => API.post('/product/configuration/group/editProduct', body),
  // 保存排序
  saveConfigProductSort: (body) => API.post('/product/configuration/group/editProductSort', body),
  // 折扣服务产品下载SOW
  exportFilesSOW:(params) => API.get('/product/BaseInfoController/getFileUrl',params),
  // 统计当前用户项目个数
  getCalCount: () => API.get('/product/project/calcount'),
  // 退出用户操作
  exitLogon: () => API.get('/product/project/exitLogon'),
  // 修改已操作的guide状态
  postUserGuide: () => API.post('/product/user/guide/read'),
  // 提交评分和意见
  addUserFeedback: (params) => API.post('/product/user/feedback/addUserFeedback', params),
  // 获取OA用户通过关键字
  getOaUserByKey: (key) => API.get('/product/user/oa', { params: { key: key } }),
  // 获取partner用户通过关键字
  getPartnerUserByKey: (key) => API.get('/product/user/partner', { params: { key: key } }),
  // 切换用户
  switchUser: (userId) => API.get('/product/switch/user', { params: { userId: userId } }),
  //  激活
  archive: (projectId) => API.get('/product/configuration/group/activation', { params: { projectId: projectId } }),
  //  代替产品信息
  replaceProductModel: (productCode, item) => API.get('/product/Replace/getReplaceProduct', { params: { productCode: productCode, item: item } }),
  //  替代品替换
  handleReplaceApi: (body) => API.post('/product/Replace/gethandleReplace', body),
  // 获取整单中riil产品的总价（只计算有固定list价的riil产品）
  getRiilProductTotalPriceByProjectId: (projectId) => API.get('/product/product/item/calRiil', { params: { projectId: projectId } }),
  // 搜索同系列添加产品列表
  getProductList: (params) => API.get('/product/BaseInfoController/getProductList', params),
  // 同系列添加产品
  addProductGroupSubItem: (body) => API.post('/product/BaseInfoController/addProductGroupSubItem', body),
  // 获取最新更新内容
  getLatestContent: () => API.get('/product/sysVersion/getSysVersionNew'),
  // 我知道了
  setVersionSwitch: () => API.get('/product/user/guide/setVersionSwitch'),
  // 获取历史更新记录
  getSysVersionHistory: () => API.get('/product/sysVersion/getSysVersionHistory'),
  // 获取已添加产品页面备注信息
  getProductRemark: (params) => API.get('/product/product/item/getProductRemark', params),
  // 获取已添加产品页面参数信息
  getParamesRemark: (params) => API.get('/product/product/item/getParamesRemark', params),
  // 保存已添加页面填写的备注信息
  saveProductRemark: (params) => API.post('/product/product/item/saveProductRemark', params),
  // 保存已添加页面填写的备注信息
  saveParamsRemark: (params) => API.post('/product/product/item/saveParamsRemark', params),
  // 切换用户权限控制
  swtichUserAuthority: () => API.get('/product/switch/swtichUserAuthority'),
  // 获取产品变更说明
  getProductChange: (params) => API.get('/product/pops/getProductChange', params),
  // 获取产品分类
  getlineProperty: (params) => API.get('/product/productLine/getlineProperty', params),
  // 根据已添加产品的系列id获取产品分类
  getSubProperty: (params) => API.get('/product/productLine/getSubProperty', params),
  // 保存配置组排序
  saveConfingGroupOrder: (params) => API.post('/product/configuration/group/saveConfingGroupOrder', params),
  // 获取可替换的产品列表
  getReplaceableProductList: (body) => API.post('/product/project/replace/list', body),
  // 替换产品
  replaceProduct: (body) => API.put('/product/project/replace', body),
  // 复制系列
  copySub: (params) => API.get('/product/project/copySub', params),
  // 删除配置组多个系列
  deleteGroupSub: (body) => API.post('/product/product/item/deleteSubAndItems', body),
  // 获取购物车数量
  getProductQuantity: (params) => API.get('/product/product/item/getProductQuantity', params),
  // 获取购物车数量
  getLowershelf: (params) => API.get('/product/product/item/getLowershelf', params),
  // 自动更新别名
  saveUserProductAlias: (body) => API.put('/product/userUserProductAlias/saveUserProductAlias', body),
  // 自动更新别名
  saveSubProductName: (body) => API.put('/product/product/item/saveSubProductName', body),
  // 收藏产品
  saveUserCollection: (params) => API.post('product/usercollection/saveUserCollection', params),
  // 获取用户收藏的产品
  queryUserCollectionList: (params) => API.post('/product/usercollection/queryUserCollectionList', params),
  // 取消收藏
  deleteUserCollection: (params) => API.get('/product/usercollection/deleteUserCollection', params),
  // 校验搜藏产品是否已经变化
  validateProduct: (body) => API.post('/product/BaseInfoController/validateProduct', body),
  // 保存产品组合包
  savePackage: (body) => API.post('/product/product/item/savePackage', body),
  getPackageProductRelationList: (params) => API.post('product/PackageProductRelation/getPackageProductRelationList', params),
  // 添加组合产品包至配置
  addPackageToGroupSubItem: (body) => API.post('/product/BaseInfoController/addPackageToGroupSubItem', body),
  // 更新单品数量
  updatePackage: (body) => API.put('/product/PackageProductRelation/updatePackage', body),
  //
  deletePackage: (params) => API.get('/product/PackageProductRelation/deletePackage', params),
  //
  getPackageLineList: (params) => API.get('/product/PackageProductRelation/line', params),
  //
  getPackageCategoriesList: (params) => API.get('/product/PackageProductRelation/categories', params),
  //
  getPackageSeriesList: (params) => API.get('/product/PackageProductRelation/series', params),

  // 获取用户文件夹树
  getUserFolderTree: (params) => API.get('/product/UserFolderProject/getUserFolderTree', params),

  addUserFold: (params) => API.post('product/UserFolderProject/addUserFold', params),

  editUserFold: (params) => API.put('product/UserFolderProject/editUserFold', params),

  removeUserFold: (params) => API.get('product/UserFolderProject/removeUserFold', params),

  moveUserFolder: (params) => API.put('product/UserFolderProject/moveUserFolder', params),

  // 查询添加页面校验信息
  getValidateInfo: (body) => API.post('/product/ProductRuleCorrelationController/getValidateInfo', body),

  // 查询已添加页面产品校验信息
  getAddedValidateInfo: (body) => API.post('/product/ProductRuleCorrelationController/getAddedValidateInfo', body),

  // 查询配置页面产品校验信息
  getConfigValidateInfo: (body) => API.post('/product/ProductRuleCorrelationController/getConfigValidateInfo', body),

  // 获取选择配件页面弱关联校验
  getWeakCorrelation: (params) => API.get('/product/ProductRuleCorrelationController/getWeakCorrelation', params),

  // 获取选择配件页面弱关联校验
  getHostValidate: (params) => API.get('/product/project/getHostValidate', params),

  // 已添加产品页面获取校验列表
  getProductRuleList: (body) => API.post('/product/ProductRuleCorrelationController/getProductRuleList', body),

  // 添加产品获取校验列表
  getAddValidateInfo: (params) => API.get('/product/ProductRuleCorrelationController/getAddValidateInfo', params),
  getUserAuth: (params) => API.get('/product/user/getUserAuth', params),
  // 渠道用户获取产品资质
  getProductQualification: (body) => API.post('/product/wpcapi/getProductQualification', body),
  // 获取分享信息
  getShareList: (params) => API.get('/product/share/getShareList', params),

  // 服务产品是否按原厂实施
  original: (params) => API.get('/product/project/original', params),

  // 获取是否按原厂实施状态
  getOriginalStatus: (params) => API.get('/product/project/getOriginalStatus', params),

  // 保存个人配置信息
  saveSettingsService: (body) => API.post('/product/userSettingsController/saveSettingsService', body),
  // 查询个人配置信息
  getUserSettings: (params) => API.get('/product/userSettingsController/getUserSettings', params),
  // 根据subId查询套数
  selectTcountbySubId: (params) => API.get('/product/project/selectTcountbySubId', params),
  // 清空回收站
  removeAll: (params) => API.get('/product/project/emptyTrash', params),
  // 添加系统授权
  addAuthUser: (body) => API.post('product/userAuth/add', body),
  // 查询授权用户
  selectAuthUser: (params) => API.get('product/userAuth/selectTable', params),
  // 删除授权用户
  deleteByuserId: (params) => API.get('product/userAuth/deleteByuserId', params),

  // 获取配置组
  getGroupName: (params) => API.get('/product/price/discount/getGroupName', params),

  // 获取小组
  getSubName: (params) => API.get('/product/price/discount/getSubName', params),
  // 我的项目(报价单)
  distinguishRefreshPrice: (params) => API.get('/product/project/distinguishRefreshPrice', params),
// 创建报价单,可销售区域
  getSellsAreaInfo: (params) => API.get(`/product/project/getCountryInfo`,params ),
  // 批量复制
  copyItems: (body) => API.post('/product/project/copyItems', body),
  user: (ticket, route) => API.get('/product/user/userInfoAuth?ticket=' + ticket + '&route=' + route),


  // 根据已选服务列表（可选）回显服务配置列表数据  选择配置服务
  productServiceEcho: (body) => API.post('/product/serve/productServiceEcho', body),
  //   单个  保存服务产品信息
  saveServiceList: (body) => API.post('/product/serve/saveServiceList', body),
  // 批量服务配置  保存服务产品信息
  batchSaveServiceList: (body) => API.post('/product/serve/batchSaveServiceList', body),
};
 